import styled from '@emotion/styled';

export const SDangerActionItem = styled.div`
  color: #ff4d4f;
`;
